import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { CircularProgress } from "@mui/material";

import ProfileBar from "../../Organisms/App Utility Bar/profilebar.js";
import RentDetails from "./rent-details";
import RentPayment from "./rent-payment.js";
import PayRentWithStakePay2 from "./pay-rent-with-stakepay.js";
import DealsCarousel from "../Deals/deals-carousel.js";
import StakeWallet from "./stake-account.js";
import OptCreditBuilder from "../Credit Builder/credit-builder";
import { useConsumerDealsData } from "../Deals/index.js";

import {
  useActivities,
  useCreditReportDetails,
  useGetRecurringDeposit,
  useRentDetails,
  useRentPayments,
  useStakeDebit,
} from "../../CustomHooks/Queries";

import { contactStakeIfErrorPersistsMessage } from "../../Utils/constants.js";

import { CloseWithShadow } from "../../Assets/Icons";

import "./home.scss";
import "./home-responsive.scss";

export default function Home() {
  const { isLoading: isLoadingRentDetails, data: rentDetails, isError: isRentDetailsError } = useRentDetails();
  const { isLoading: isLoadingActivities, isError: isActivitiesError } = useActivities();
  const {
    isLoading: isLoadingCreditReporting,
    data: creditReporting,
    isError: isCreditReportingError,
  } = useCreditReportDetails();
  const { isLoading: isLoadingRecurringDeposit, isError: isRecurringDepositError } = useGetRecurringDeposit();
  const { isLoading: isLoadingStakeDebit, isError: isStakeDebitError } = useStakeDebit();
  const { isLoading: isLoadingRentPayments, isError: isRentPaymentError } = useRentPayments();

  const {
    isLoadingConsumerDealsData,
    consumerDealsAPI: { error: isConsumerDealsError },
    offers,
  } = useConsumerDealsData();

  const isCreditReportingEligible = useMemo(() => {
    return creditReporting?.data?.data?.credit_builder?.is_eligible;
  }, [creditReporting?.data?.data?.credit_builder?.is_eligible]);

  const isRentPaymentVisible = useMemo(() => {
    return rentDetails?.data?.data?.rent_payment?.is_rent_payment_visible;
  }, [rentDetails]);

  const isLoading =
    isLoadingRentDetails ||
    isLoadingCreditReporting ||
    isLoadingRentPayments ||
    isLoadingConsumerDealsData ||
    isLoadingStakeDebit ||
    isLoadingActivities ||
    isLoadingRecurringDeposit;

  const isError =
    isRentDetailsError ||
    isCreditReportingError ||
    isRentPaymentError ||
    isConsumerDealsError ||
    isStakeDebitError ||
    isActivitiesError ||
    isRecurringDepositError;

  return (
    <div className="home">
      <section>
        <div className="max-width-container">
          {isLoading ? (
            <div className="loading-content">
              <CircularProgress />
            </div>
          ) : isError ? (
            <div className="error-content">
              <CloseWithShadow />
              <div className="error-description">{contactStakeIfErrorPersistsMessage}</div>
            </div>
          ) : (
            <>
              <ProfileBar />
              <Row className="row-gap-sm-6 row-gap-4">
                <Col lg={6}>
                  <StakeWallet />
                </Col>
                <Col lg={6}>
                  <RentDetails />
                </Col>
                <Col xs={12}>
                  <PayRentWithStakePay2 />
                </Col>
                {offers?.length > 0 && (
                  <Col lg={isCreditReportingEligible ? 6 : 12}>
                    <DealsCarousel />
                  </Col>
                )}
                {isCreditReportingEligible && (
                  <Col lg={offers?.length > 0 ? "6" : "12"}>
                    <OptCreditBuilder useAsNavigationCard={true} />
                  </Col>
                )}
                {isRentPaymentVisible && (
                  <Col xs={12}>
                    <RentPayment />
                  </Col>
                )}
              </Row>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
